module.exports = __webpack_public_path__ + "static/media/immovable.8814d66c.ogg";